<template>
  <div class="baby-dialog-shade" id="dialogBox">
    <div>
      <div class="baby-dialog">
        <div class="top">
          <div class="line"></div>
          <div class="title" style="color: #FFFFFF">提示</div>
          <img class="close-img" src="../../assets/img/close.png" @click="closeDialog">
        </div>
        <div class="tip">{{ tip }}</div>
        <slot></slot>
        <div class="foot">
          <div class="box2" @click="closeDialog">取消</div>
          <div class="box4" @click="confirmDialog">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BabyDialog",
  props: {
    tip: { type: String, default: ''},
  },
  directives: {
    ClickOutSide: {
      inserted(el, binding) {
        function handleFun(e) { // 判断所点击dom是否为el的节点
          if (el.contains(e.target)) {
            console.log('在节点内')
          } else {
            console.log('在节点外')
            binding.value(e)
          }
        }
        el.function = handleFun
        document.getElementById('dialogBox').addEventListener('click', el.function)
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    confirmDialog() {
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped lang="less">
.baby-dialog-shade {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(51, 51, 51, 0.4);

  .baby-dialog {
    width: 596px;
    height: auto;
    background-image: url("../../assets/dp/confirm-box.png");
    background-size: 100% 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    padding-bottom: 80px;
    transform: translate(-50%, -50%);
    .top{
      width: calc(100% - 10px);
      margin-left: 5px;
      height: 40px;
      line-height: 40px;
      font-size: 20px;
      text-shadow: 3px 3px 5px #32b0f8;
      border-bottom: 1px solid #4A96C5;
      display: flex;
      position: relative;
      .line{
        width: 4px;
        height: 26px;
        background-color: #00B2FF;
        margin-right: 10px;
        margin-top: 4px;
      }
      .close-img{
        position: absolute;
        right: 10px;
        top: 15px;
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }
    .tip{
      font-size: 26px;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      line-height: 100px;
      text-shadow: 3px 3px 5px #32b0f8;
    }
    .foot{
      display: flex;
      position: absolute;
      bottom: 30px;
      justify-content: center;
      width: 100%;
      div{
        height: 50px;
        width: 190px;
        background-size: 100% 100%;
        text-align: center;
        line-height: 50px;
        font-size: 20px;
        cursor: pointer;
      }
      .box2{
        background-image: url("../../assets/img/box2.png");
        color: #00FFF6;
      }
      .box4{
        background-image: url("../../assets/img/box4.png");
        color: #00B2FF;
      }
    }
  }
}
</style>
